import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let changeRequired = useDataChange({
    context: 'question',
    path: 'required',
    viewPath: props.viewPath,
  })

  let changeHidden = useDataChange({
    context: 'question',
    path: 'hidden',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    changeRequired(value)
    if (value === true) {
      changeHidden(false)
    }
  }
}
